// assets/nd-cart-replace-finalize.js  (v1.1 NO-FLASH + SECTION-RENDER)
// Goal:
// - On /cart page, if sessionStorage has ND:PENDING_REPLACE with ndLineKey,
//   remove that old line item key via /cart/change.js (quantity=0),
//   then re-render cart sections ONCE (no full reload) => user無感 replace

(function () {
  if (window.__ND_CART_REPLACE_FINALIZE_V11__) return;
  window.__ND_CART_REPLACE_FINALIZE_V11__ = true;

  var TAG = "[ND][CART_REPLACE_FINALIZE_V11]";
  function log(){ try{ console.log.apply(console,[TAG].concat([].slice.call(arguments))); }catch(e){} }
  function warn(){ try{ console.warn.apply(console,[TAG].concat([].slice.call(arguments))); }catch(e){} }

  function isCartPage(){
    try{ return (location.pathname||"").toLowerCase().indexOf("/cart") === 0; }catch(e){ return false; }
  }
  if (!isCartPage()) return;

  // ✅ Your real section ids (from your console)
  var CART_SECTION_IDS = [
    "template--26685941678402__main-cart-items",
  "template--26685941678402__main-cart-footer"
  ];

  // ===== Minimal UX veil (built-in) =====
  function ND_beginReplaceUX() {
    if (document.getElementById('nd-replace-veil')) return;
    var style = document.createElement('style');
    style.id = 'nd-replace-veil-style';
    style.textContent = `
      #nd-replace-veil{ position:fixed; inset:0; z-index:999999;
        background: rgba(255,255,255,0.01); cursor: progress; }
      .nd-replace-lock *{ pointer-events:none !important; }
      .nd-replace-dim{ opacity: 0.25 !important; transition: opacity .12s ease; }
    `;
    document.head.appendChild(style);

    var veil = document.createElement('div');
    veil.id = 'nd-replace-veil';
    document.body.appendChild(veil);

    var cartRoot = document.querySelector('form[action="/cart"]') || document.querySelector('main') || document.body;
    cartRoot.classList.add('nd-replace-dim');

    document.documentElement.classList.add('nd-replace-lock');
    try { document.body.style.overflow = 'hidden'; } catch (e) {}
  }

  function ND_endReplaceUX() {
    var veil = document.getElementById('nd-replace-veil');
    if (veil) veil.remove();

    var style = document.getElementById('nd-replace-veil-style');
    if (style) style.remove();

    var cartRoot = document.querySelector('form[action="/cart"]') || document.querySelector('main') || document.body;
    cartRoot.classList.remove('nd-replace-dim');

    document.documentElement.classList.remove('nd-replace-lock');
    try { document.body.style.overflow = ''; } catch (e) {}
  }

  async function ND_renderCartSectionsOnce(sectionIds) {
    // Shopify sections rendering endpoint
    var url = "/?sections=" + encodeURIComponent(sectionIds.join(","));
    var res = await fetch(url, { credentials: "same-origin", cache: "no-store" });
    if (!res.ok) throw new Error("sections fetch failed: " + res.status);
    var data = await res.json();

    sectionIds.forEach(function(id){
      var html = data[id];
      if (!html) return;
      var host = document.getElementById("shopify-section-" + id);
      if (!host) return;
      host.innerHTML = html;
    });
  }

  function readPending(){
    try{
      var raw = sessionStorage.getItem("ND:PENDING_REPLACE");
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ndLineKey) return null;
      return obj;
    }catch(e){ return null; }
  }

  function clearPending(){
    try{ sessionStorage.removeItem("ND:PENDING_REPLACE"); }catch(e){}
  }

  async function removeOldLineKey(lineKey){
    var body = new URLSearchParams();
    body.set("id", String(lineKey));
    body.set("quantity", "0");

    var res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
      credentials: "same-origin",
      body: body.toString()
    });

    if (!res.ok) {
      var txt = "";
      try{ txt = await res.text(); }catch(e){}
      throw new Error("change.js failed: " + res.status + " " + txt.slice(0,200));
    }
    return res.json().catch(function(){ return null; });
  }

  // 🔁 optional: after re-render, re-init your injected buttons if you have a known global init
  function reInitAfterRerender(){
    // 你如果有自己的 init function，可在這裡補上名稱（不確定就先留著不動）
    try{
      if (typeof window.ND_cartInit === "function") window.ND_cartInit();
      if (typeof window.__ND_CART_OPTIS_EMBED_EDIT_REINIT__ === "function") window.__ND_CART_OPTIS_EMBED_EDIT_REINIT__();
    }catch(e){}
  }

  async function run(){
    var p = readPending();
    if (!p) return;

    // 防止重複跑
    if (window.__ND_CART_REPLACE_RUNNING__) return;
    window.__ND_CART_REPLACE_RUNNING__ = true;

    // ✅ 一進來就遮住，使用者看不到中間態
    ND_beginReplaceUX();

    try{
      log("pending found:", p);

      // ⚠️ 重要：先刪舊 line（新 line 已經在前一頁 add 完了）
      await removeOldLineKey(p.ndLineKey);
      log("old line removed:", p.ndLineKey);

      // 清 pending，避免下一次進 cart 又刪一次
      clearPending();

      // ✅ 只重繪 cart 的 items + footer（不整頁 reload）=> 幾乎無感
      await ND_renderCartSectionsOnce(CART_SECTION_IDS);

      // 重繪後重新掛回你自己的按鈕/事件（如果有）
      reInitAfterRerender();

      // 下一個 frame 再放開，避免看到 DOM 最後一抖
      requestAnimationFrame(function(){ ND_endReplaceUX(); });

    }catch(e){
      warn("finalize failed:", e);
      clearPending();
      // 失敗也不要卡住使用者
      requestAnimationFrame(function(){ ND_endReplaceUX(); });
    }finally{
      setTimeout(function(){ window.__ND_CART_REPLACE_RUNNING__ = false; }, 1200);
    }
  }

  // ✅ 不用再等 200ms；越快越不會被看到中間態
  // 但為了讓主題先把 cart sections render 出來（確保 host element 存在），用最小延遲：
  setTimeout(run, 0);
})();
